<div class="container">
  <mat-card>
    <form
      [formGroup]="userForm"
      (ngSubmit)="submit()"
      matomoForm="Create User Form"
    >
      <mat-card-content>
        <div fxLayout="row wrap" fxLayoutGap="2%" fxLayout.lt-md="column">
          <mat-form-field fxFlex="48%">
            <mat-label>{{ "USERS.EMAIL" | translate }}</mat-label>
            <input
              matInput
              [required]="userForm.controls.sendPasswordToEmail.value"
              formControlName="email"
            />
            <mat-error *ngIf="userForm.controls.email.hasError('email')">
              {{ "VALIDATION.EMAIL_INVALID" | translate }}
            </mat-error>
            <mat-error *ngIf="userForm.controls.email.hasError('required')">
              {{ "VALIDATION.EMAIL_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
          <br />

          <mat-form-field fxFlex="48%">
            <mat-label>{{ "USERS.FIRST_NAME" | translate }}</mat-label>
            <input matInput required formControlName="firstname" />
            <mat-error *ngIf="userForm.controls.firstname.hasError('pattern')">
              {{ "VALIDATION.FIRST_NAME_PATTERN" | translate }}
            </mat-error>
            <mat-error *ngIf="userForm.controls.firstname.hasError('required')">
              {{ "VALIDATION.FIRST_NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="48%">
            <mat-label>{{ "USERS.LAST_NAME" | translate }}</mat-label>
            <input matInput required formControlName="lastname" />
            <mat-error *ngIf="userForm.controls.lastname.hasError('pattern')">
              {{ "VALIDATION.LAST_NAME_PATTERN" | translate }}
            </mat-error>
            <mat-error *ngIf="userForm.controls.lastname.hasError('required')">
              {{ "VALIDATION.LAST_NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>

          <div fxFlex="48%" class="password-never-expires-wrapper">
            <mat-checkbox
              labelPosition="before"
              formControlName="passwordNeverExpires"
            >
              {{ "USERS.OVERRIDE_PASSWORD_EXPIRY" | translate }}
            </mat-checkbox>
          </div>

          <div fxFlex="48%" class="send-password-to-email-wrapper">
            <mat-checkbox
              labelPosition="before"
              formControlName="sendPasswordToEmail"
            >
              {{ "USERS.AUTO_GENERATE_PASSWORD" | translate }}
            </mat-checkbox>
          </div>

          <mat-form-field
            fxFlex="48%"
            *ngIf="!userForm.controls.sendPasswordToEmail.value"
          >
            <mat-label>{{ "COMMON.PASSWORD" | translate }}</mat-label>
            <input
              matInput
              required
              type="password"
              formControlName="password"
            />
            <mat-error *ngIf="userForm.controls.password.hasError('required')">
              {{ "VALIDATION.PASSWORD_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>

          <mat-form-field
            fxFlex="48%"
            *ngIf="!userForm.controls.sendPasswordToEmail.value"
          >
            <mat-label>{{ "USERS.REPEAT_PASSWORD" | translate }}</mat-label>
            <input
              matInput
              required
              type="password"
              formControlName="repeatPassword"
            />
            <mat-error
              *ngIf="userForm.controls.repeatPassword.hasError('required')"
            >
              {{ "VALIDATION.PASSWORD_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>

          <p
            fxFlex="98%"
            class="reset-password-error"
            *ngIf="
              userForm.errors?.passwordsDoNotMatch &&
              !userForm.controls.password.hasError('required') &&
              !userForm.controls.repeatPassword.hasError('required')
            "
          >
            {{ "VALIDATION.PASSWORDS_DO_NOT_MATCH" | translate }}
          </p>

          <mat-form-field fxFlex="48%">
            <mat-label>{{ "USERS.ROLES" | translate }}</mat-label>
            <mat-select required formControlName="roles" multiple>
              <mat-option *ngFor="let role of rolesData" [value]="role.id">
                {{ role.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="userForm.controls.roles.hasError('required')">
              {{ "VALIDATION.ROLES_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions
        fxLayout="row"
        fxLayout.xs="column"
        fxLayoutAlign="center"
        fxLayoutGap="5px"
      >
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ "COMMON.CANCEL" | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!userForm.valid">
          {{ "COMMON.SUBMIT" | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
